module.exports = __webpack_public_path__ + "static/media/starProduct5.908e925c.png";